import useSWR from "swr";
import { fetcher } from "../lib/api";
import type { SummaryResponse } from "../types/api";

export function useSummary(tickId: string | null) {
  const key = tickId ? `/summary?tick_id=${encodeURIComponent(tickId)}` : null;
  const { data, error, isLoading } = useSWR<SummaryResponse>(key, fetcher);
  return { summary: data, isLoading, error };
}
